// a set of widgets you can use in the editor, optional.
import '@builder.io/widgets'
import { Builder, builder } from '@builder.io/react'
import loadable from '@loadable/component'
import { LinkButtonRegisterProps } from './components/ui-builder/common/button'
import { headingClassPropObj, headingTypePropObj } from './components/ui-builder/common/heading'
import { StepItemRegisterProps } from './components/ui-builder/steps/step-item'
import BulletPointImage from './images/BulletPoint.svg'
import BgFooter from './images/builder/Wavybackground.svg'

/**
 * Import all custom components so you can use in the builder.io editor
 * https://www.builder.io/c/docs/custom-react-components
 */
import './components/ui-builder/accordion'
import './components/ui-builder/recipe-components/recipe-additives-lister'
import './components/ui-builder/back-button'
//import './components/ui-builder/banner';
import './components/ui-builder/banner-alternate'
import './components/ui-builder/banner-with-icons'
import LazyHeroThree from './components/ui-builder/hero/hero-three'
import './components/ui-builder/hero/hero-four'
import HeroDogCTA from './components/ui-builder/hero/hero-dog-cta'
import HeroDogCTAAlternate from './components/ui-builder/hero/hero-dog-cta-alternate'
import HeroDogCTAVersionTwo from './components/ui-builder/hero/hero-dog-cta-version-two'
import HeroDogName from './components/ui-builder/hero/hero-dog-name'
import HeroDogNameAlternate from './components/ui-builder/hero/hero-dog-name-alternate'
import HeroDogNameVersionTwo from './components/ui-builder/hero/hero-dog-name-version-two'
import HeroDoubleImage from './components/ui-builder/hero/hero-double-image'
import './components/ui-builder/hero/hero-treats-cta'
import './components/ui-builder/hero-calculator'
import './components/ui-builder/header-with-dropdowns'
//import './components/ui-builder/header';
import './components/ui-builder/bullet-section'
import './components/ui-builder/dog-story'
import './components/ui-builder/experts-section'
import './components/ui-builder/feature-bar'
import './components/ui-builder/specs-section'
import './components/ui-builder/text-on-color-bg'
import './components/ui-builder/blog-components/blog-back-button'
import './components/ui-builder/blog-components/blog-text'
import './components/ui-builder/blog-components/blog-text-image-cta'
import './components/ui-builder/heading'
import './components/ui-builder/heading-alternate'
//import './components/ui-builder/column-with-images';
import './components/ui-builder/faq'
import './components/ui-builder/faq-alternate'
import './components/ui-builder/comparison-table'
import './components/ui-builder/comparison-table-alternate'
import './components/ui-builder/comparison-table-alternate-two'
import './components/ui-builder/links-two'
import './components/ui-builder/recipe-of-the-month'
import './components/ui-builder/social-links'
import './components/ui-builder/testimonials/testimonialOne'
import './components/ui-builder/testimonials/testimonialTwo'
//import './components/ui-builder/logo-cloud';
import './components/ui-builder/text-no-image'
import './components/ui-builder/text-image'
import './components/ui-builder/text-image/text-three-image'
import './components/ui-builder/text-image-no-button'
import './components/ui-builder/text-image-with-button'
import './components/ui-builder/text-with-button'
import './components/ui-builder/text-image-landing-page'
import './components/ui-builder/landing-page/top-text-image'
import './components/ui-builder/landing-page/three-image-text'
import './components/ui-builder/simple-three-columns'
import './components/ui-builder/teams'
import './components/ui-builder/newsletter-section'
import './components/ui-builder/cta/cta-one'
import './components/ui-builder/cta/cta-two'
import './components/ui-builder/cta/cta-three'
import './components/ui-builder/cta/cta-four'
import './components/ui-builder/cta/cta-five'
import './components/ui-builder/cta/cta-six'
import './components/ui-builder/food-compare'
import './components/ui-builder/common/padder'
import './components/ui-builder/support-section'
//import './components/ui-builder/footer';
import './components/ui-builder/blog-lister'
// import './components/ui-builder/trustpilot/carousel';
// import './components/ui-builder/trustpilot/micro-combo';
// import './components/ui-builder/trustpilot/both';
import './components/ui-builder/recipe-lister'
// import './components/ui-builder/recipe-lister-alternate'
import './components/ui-builder/paragarph'
import './components/ui-builder/simple-three-columns-simple'
import './components/ui-builder/mention-me'
// import './components/ui-builder/yotpo'
//import './components/ui-builder/steps'
import './components/ui-builder/slider'
import './components/ui-builder/slider-text'
import './components/ui-builder/column'
import './components/ui-builder/bg-filler'
import './components/ui-builder/bg-filler-mobile'
import './components/ui-builder/comparison-dog-food'
import './components/ui-builder/numbered-steps'
import './components/ui-builder/video-player'
import './components/ui-builder/templates/recipe/recipe'
import './components/ui-builder/recipe-book'
import './components/ui-builder/blog-one'
import './components/ui-builder/recipe-spotlight'
import './components/ui-builder/image/responsive-image'
import './components/ui-builder/instagram-grid'
import './components/ui-builder/instagram-section'
import './components/ui-builder/lightbox'
import './components/ui-builder/blog-hero'
import './components/ui-builder/steps-three'
import './components/ui-builder/hero/hero-five'
import './components/ui-builder/treat-lister'
import './components/ui-builder/contact-us'
import './components/ui-builder/our-story-header'
import './components/ui-builder/our-story-image/our-story-image'
import './components/ui-builder/recipe-card/recipe-card'
import './components/ui-builder/review-card/review-card'
import './components/ui-builder/review-card/review-card-carousel'
import './components/ui-builder/reviews-section'
import './components/ui-builder/recipe-lister-alternate'
import './components/ui-builder/running-line/discount'
import './components/ui-builder/running-line/multi'
import './components/ui-builder/section-arrow-button'
import './components/ui-builder/skeleton/skeleton-header'
import './components/ui-builder/skeleton/skeleton-text'
import './components/ui-builder/skeleton/skeleton-image'
import './components/ui-builder/steps-section/four-step-section'
import './components/ui-builder/sticky-footer'
import './components/ui-builder/turbo-route'
import AbContainer from './components/ui-builder/ab/ab-container'
import AbSkeleton from './components/ui-builder/ab/ab-skeleton'
import AbTest from './components/ui-builder/ab/ab-test'
import Container from './components/ui-builder/ab/container'

/**
 * LAZY LOADED BUILDER COMPONENTS BELOW
 */

const LazyLogoCloud = loadable(() => import('components/ui-builder/logo-cloud'))
Builder.registerComponent(LazyLogoCloud, {
  name: 'LogoCloud',
  inputs: [
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'textColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'isHeadingEnabled',
      type: 'boolean',
      defaultValue: true
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'The worlds most innovative companies use Workflow'
    },
    {
      name: 'logos',
      type: 'list',
      defaultValue: [{ imgSrc: null, alt: 'defaultName' }],
      subFields: [
        { name: 'alt', type: 'string', defaultValue: 'defaultName' },
        // { name: 'cloudinaryLogoImage', type: 'cloudinaryImageEditor' },
        {
          name: 'builderLogoImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
      ]
    }, 
  ]
})

const LazyLogoCloudAlternate = loadable(() => import('components/ui-builder/logo-cloud-alternate'))
Builder.registerComponent(LazyLogoCloudAlternate, {
  name: 'LogoCloudAlternate',
  inputs: [
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'textColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'isHeadingEnabled',
      type: 'boolean',
      defaultValue: true
    },
    {
      ...headingTypePropObj
    },
    {
      ...headingClassPropObj
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: 'The worlds most innovative companies use Workflow'
    },
    {
      name: 'logos',
      type: 'list',
      defaultValue: [{ imgSrc: null, alt: 'defaultName' }],
      subFields: [
        { name: 'alt', type: 'string', defaultValue: 'defaultName' },
        // { name: 'cloudinaryLogoImage', type: 'cloudinaryImageEditor' },
        {
          name: 'builderLogoImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },    
      ]
    },
  ]
})

const LazyBanner = loadable(() => import('components/ui-builder/banner'))
Builder.registerComponent(LazyBanner, {
  name: 'Banner',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'green'
    },
    // {
    //   name: 'bannerPosition',
    //   type: 'string',
    //   defaultValue: 'top',
    //   enum: ['bottom', 'top']
    // },
    {
      name: 'enableCarousel',
      type: 'boolean',
      defaultValue: false,
      helperText: 'Please ensure the longer text is first in the carousel to set the correct width'
    },
    {
      name: 'bannerTopic',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'bannerTopicCarousel',
      type: 'richText',
      defaultValue: '',
      helperText: 'This will fade in and out with the bannerTopic text, if enabled'
    },
    {
      name: 'bannerTopicLong',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'bannerTopicLongCarousel',
      type: 'richText',
      defaultValue: '',
      helperText: 'This will fade in and out with the bannerTopicLong text, if enabled'
    },
    {
      name: 'buttonTextCarousel',
      type: 'text',
      defaultValue: '',
      helperText: 'This will fade in and out with the bannerTopicLong text, if enabled'
    },
    {
      name: 'buttonUrlCarousel',
      type: 'text',
      defaultValue: '#',
      helperText: 'This will fade in and out with the bannerTopicLong text, if enabled'
    },
    {
      name: 'fontColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'centered',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'stickyBottom',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps
    }
  ]
})

const LazyTrustPilotCombo = loadable(() => import('components/ui-builder/trustpilot/both'))
Builder.registerComponent(LazyTrustPilotCombo, {
  name: 'TrustPilotCombo',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'widgetType',
      type: 'string',
      enum: ['carousel', 'microCombo', 'list'],
      defaultValue: 'microCombo'
    },
    {
      name: 'tags',
      type: 'text',
      defaultValue: ''
    }
  ]
})

const LazyHeader = loadable(() => import('components/ui-builder/header'))
Builder.registerComponent(LazyHeader, {
  name: 'Header',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'fontColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'logo',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'navigation',
      type: 'list',
      defaultValue: [{ navName: 'About', link: '#' }],
      subFields: [
        { name: 'navName', type: 'string', defaultValue: 'About' },
        { name: 'link', type: 'string', defaultValue: '#' }
      ]
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonOneProp'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonTwoProp'
    }
  ]
})

const LazyHeaderWithWave = loadable(() => import('components/ui-builder/header-with-wave'))
Builder.registerComponent(LazyHeaderWithWave, {
  name: 'HeaderWithWave',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'fontColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'logo',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'navigation',
      type: 'list',
      defaultValue: [{ navName: 'About', link: '#' }],
      subFields: [
        { name: 'navName', type: 'string', defaultValue: 'About' },
        { name: 'link', type: 'string', defaultValue: '#' }
      ]
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonOneProp'
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonTwoProp'
    }
  ]
})

const LazyColumnWithImages = loadable(() => import('components/ui-builder/column-with-images'))
Builder.registerComponent(LazyColumnWithImages, {
  name: 'ColumnWithImages',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'stepDescriptionTitleTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'stepDescriptionTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'steps',
      type: 'list',
      defaultValue: [
        {
          imageSrc: null,
          imageAltText: '',
          descriptionTitleText: 'Step one Title',
          descriptionTitleTextAlignment: 'left',
          descriptionText: 'Step one Description',
          descriptionTextExtra: 'Step one Description Extra',
          descriptionTextAlignment: 'left',
          stepBackgroundColor: '#F9F5F1',
          optimalImgEnable: true,
          linkLabel: 'Step one',
          link: '/stepOne',
        }
      ],
      subFields: [
        // { name: 'cloudinaryImage', type: 'cloudinaryImageEditor' },
        {
          name: 'builderImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
        { name: 'imageAltText', type: 'text', defaultValue: '' },
        { name: 'descriptionTitleText', type: 'richText', defaultValue: 'Step one Title' },
        {
          name: 'descriptionTitleTextAlignment',
          type: 'string',
          enum: ['left', 'center', 'right'],
          defaultValue: 'left'
        },
        { name: 'descriptionText', type: 'richText', defaultValue: 'Step one description' },
        { name: 'descriptionTextExtra', type: 'richText', defaultValue: 'Step one description extra' },
        { name: 'descriptionTextAlignment', type: 'string', enum: ['left', 'center', 'right'], defaultValue: 'left' },
        { name: 'stepBackgroundColor', type: 'color', defaultValue: '#F9F5F1' },
        { name: 'optimalImgEnable', type: 'boolean', defaultValue: true },
        { name: 'linkLabel', type: 'text', defaultValue: '' },
        { name: 'link', type: 'text', defaultValue: '/treats' },
      ]
    },
    {
      name: 'optionalImage',
      type: 'boolean',
      defaultValue: true
    },
    // { name: 'cloudinaryOptionalImage', type: 'cloudinaryImageEditor' },
    {
      name: 'builderOptionalImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },

    {
      name: 'optionalImageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'buttonOneProp',
      type: 'object',
      defaultValue: {
        buttonColor: 'white',
        buttonText: 'Create Your Plan',
        buttonTextColor: 'black',
        buttonUrl: '#',
        isLink: false
      },
      subFields: [
        { name: 'buttonColor', type: 'color', defaultValue: 'white' },
        { name: 'buttonText', type: 'string', defaultValue: 'Create Your Plan' },
        { name: 'loggedInButtonText', type: 'string', defaultValue: 'Logged In' },
        { name: 'buttonTextColor', type: 'color', defaultValue: 'black' },
        { name: 'buttonUrl', type: 'text', defaultValue: '#' },
        { name: 'isLink', type: 'boolean', defaultValue: false },
        { name: 'outline', type: 'boolean', defaultValue: false },
      ]
    },
    {
      name: 'imageProperty',
      type: 'string',
      enum: ['object-contain', 'object-cover'],
      defaultValue: 'object-cover'
    },
    {
      name: 'imageOrientation',
      type: 'text',
      enum: ['landscape', 'portrait'],
      defaultValue: 'portrait'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: true
    },
  ]
})

Builder.registerComponent(LazyHeroThree, {
  name: 'HeroThree',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    // {
    //   name: 'cloudinaryTextImage',
    //   type: 'cloudinaryImageEditor'
    // },
    // {
    //   name: 'cloudinaryHeroTextImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderTextImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'builderHeroTextImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },

    {
      name: 'heroTextImgAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'image',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'videoHero',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'videoSrc',
      type: 'file',
      allowedFileTypes: ['mp4']
    },
    {
      name: 'cloudinaryVideo',
      type: 'cloudinaryImageEditor'
    },
    {
      name: 'playbackSettings',
      type: 'string',
      enum: ['Muted with auto play off', 'Muted with auto play on', 'Sound on with auto play off'],
      defaultValue: 'Muted with auto play off'
    },
    {
      name: 'videoShouldLoop',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'mediaBackdropColor',
      type: 'color',
      defaultValue: 'cyan'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    }
  ]
})

Builder.registerComponent(HeroDogName, {
  name: 'HeroDogName',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    // {
    //   name: 'cloudinaryTextImage',
    //   type: 'cloudinaryImageEditor'
    // },
    // {
    //   name: 'cloudinaryHeroTextImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderTextImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'builderHeroTextImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'heroTextImgAltText',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'image',
    //   type: 'cloudinaryImageEditor'
    // },
    // {
    //   name: 'mobileImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'builderMobileImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },

    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'videoHero',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'videoSrc',
      type: 'file',
      allowedFileTypes: ['mp4']
    },
    // {
    //   name: 'cloudinaryVideo',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'playbackSettings',
      type: 'string',
      enum: ['Muted with auto play off', 'Muted with auto play on', 'Sound on with auto play off'],
      defaultValue: 'Muted with auto play off'
    },
    {
      name: 'videoShouldLoop',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'mediaBackdropColor',
      type: 'color',
      defaultValue: 'cyan'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    {
      name: 'heroFooterBackground',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'heroFooterBackgroundMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'coupon',
      type: 'text',
      defaultValue: ''
    }
  ]
})

Builder.registerComponent(HeroDogNameAlternate, {
  name: 'HeroDogNameAlternate',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'cdnVideoImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    // {
    //   name: 'cloudinaryTextImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'videoSrc',
      type: 'file',
      allowedFileTypes: ['mp4']
    },
    {
      name: 'builderTextImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    // {
    //   name: 'cloudinaryVideoImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'cloudinaryTextImageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'videoHero',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'cloudinaryVideo',
      type: 'cloudinaryImageEditor'
    },
    {
      name: 'playbackSettings',
      type: 'string',
      enum: ['Muted with auto play off', 'Muted with auto play on', 'Sound on with auto play off'],
      defaultValue: 'Muted with auto play off'
    },
    {
      name: 'videoShouldLoop',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'roundedCorners',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'mediaBackdropColor',
      type: 'color',
      defaultValue: 'cyan'
    },
    {
      name: 'widgetBackgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'widgetType',
      type: 'string',
      enum: ['carousel', 'microCombo', 'list'],
      defaultValue: 'microCombo'
    },
    {
      name: 'widgetTags',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'ratingTextBold',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'ratingTextNormalOne',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'ratingTextNormalTwo',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'ratingIcon',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderRatingIcon',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'tagline',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'displayTagline',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'heroFooterBackground',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'leftSection',
      type: 'string',
      enum: ['image', 'textImage', 'textImageWithAsterix'],
      defaultValue: 'image'
    },
    {
      name: 'titleOne',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'titleOneBold',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'contentText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'coupon',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'highlightedOfferText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'highlightedOffer',
      type: 'boolean',
      defaultValue: false
    }
  ]
})

Builder.registerComponent(HeroDogNameVersionTwo, {
  name: 'HeroDogNameVersionTwo',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    // {
    //   name: 'backgroundImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderBackgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'builderBackgroundImageWide',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'backgroundImageToLeft',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'backgroundImageAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'titleTextOne',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'titleTextTwo',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'tagLine',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'widgetBackgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'widgetType',
      type: 'string',
      enum: ['carousel', 'microCombo', 'list'],
      defaultValue: 'microCombo'
    },
    {
      name: 'widgetTags',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'widgetColor',
      type: 'color',
      defaultValue: '#004355'
    },
    {
      name: 'widgetPlaceholder',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'heroFooterBackground',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    {
      name: 'defaultOffer',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'couponText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'showCouponText',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'growthbookFeatureId',
      friendlyName: 'Growthbook Feature ID',
      type: 'string',
      defaultValue: ''
    },
    {
      name: 'enabled',
      friendlyName: 'Enabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'removeFormSection',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'removeWidget',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'showTrustpilotImage',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'formType',
      type: 'string',
      enum: ['breed', 'name', 'cta'],
      defaultValue: ''
    },
  ]
})

Builder.registerComponent(HeroDogCTA, {
  name: 'HeroDogCTA',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    // {
    //   name: 'cloudinaryTextImage',
    //   type: 'cloudinaryImageEditor'
    // },
    // {
    //   name: 'cloudinaryHeroTextImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderTextImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },{
      name: 'builderHeroTextImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'heroTextImgAltText',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'image',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    // {
    //   name: 'mobileImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderMobileImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'imageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'videoHero',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'videoSrc',
      type: 'file',
      allowedFileTypes: ['mp4']
    },
    {
      name: 'cloudinaryVideo',
      type: 'cloudinaryImageEditor'
    },
    {
      name: 'playbackSettings',
      type: 'string',
      enum: ['Muted with auto play off', 'Muted with auto play on', 'Sound on with auto play off'],
      defaultValue: 'Muted with auto play off'
    },
    {
      name: 'videoShouldLoop',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'mediaBackdropColor',
      type: 'color',
      defaultValue: 'cyan'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    {
      name: 'heroFooterBackground',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'heroFooterBackgroundMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'coupon',
      type: 'text',
      defaultValue: ''
    }
  ]
})

Builder.registerComponent(HeroDogCTAAlternate, {
  name: 'HeroDogCTAAlternate',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    // {
    //   name: 'cloudinaryHeaderImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderHeaderImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'cloudinaryHeaderImageAltText',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'cloudinaryTextImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderTextImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'cloudinaryTextImageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    {
      name: 'widgetBackgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'widgetType',
      type: 'string',
      enum: ['carousel', 'microCombo', 'list'],
      defaultValue: 'microCombo'
    },
    {
      name: 'widgetTags',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'ratingTextBold',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'ratingTextNormalOne',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'ratingTextNormalTwo',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'ratingIcon',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderRatingIcon',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'tagline',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'displayTagline',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'heroFooterBackground',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'leftSection',
      type: 'string',
      enum: ['image', 'textImage', 'textImageWithAsterix'],
      defaultValue: 'image'
    },
    {
      name: 'titleOne',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'titleOneBold',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'contentText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'coupon',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'highlightedOfferText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'highlightedOffer',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'showBackgroundFooter',
      type: 'boolean',
      defaultValue: true
    }
  ]
})

Builder.registerComponent(HeroDogCTAVersionTwo, {
  name: 'HeroDogCTAVersionTwo',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'isImageFirst',
      type: 'boolean',
      defaultValue: true
    },
    // {
    //   name: 'backgroundImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderBackgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'backgroundImageAlt',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'titleTextOne',
      type: 'text',
      defaultValue: ''
    },    {
      name: 'titleTextTwo',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'tagLine',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'headlineWidth',
      type: 'string',
      enum: ['4/5', 'full'],
      defaultValue: '4/5'
    },
    {
      name: 'textAlignment',
      type: 'string',
      enum: ['left', 'center', 'right'],
      defaultValue: 'left'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    {
      name: 'widgetBackgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'widgetType',
      type: 'string',
      enum: ['carousel', 'microCombo', 'list'],
      defaultValue: 'microCombo'
    },
    {
      name: 'widgetTags',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'widgetColor',
      type: 'color',
      defaultValue: '#004355'
    },
    {
      name: 'widgetPlaceholder',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'heroFooterBackground',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'coupon',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'defaultOffer',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'couponText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'growthbookFeatureId',
      friendlyName: 'Growthbook Feature ID',
      type: 'string',
      defaultValue: ''
    },
    {
      name: 'enabled',
      friendlyName: 'Enabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'removeFormSection',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'removeWidget',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'showTrustpilotImage',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'showExtraMessage',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'formType',
      type: 'string',
      enum: ['breed', 'name', 'cta'],
      defaultValue: ''
    },
  ]
})

Builder.registerComponent(HeroDoubleImage, {
  name: 'HeroDoubleImage',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    // {
    //   name: 'cloudinaryImageLeft',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImageLeft',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'cloudinaryImageLeftAltText',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'cloudinaryImageRight',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderImageRight',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'cloudinaryImageRightAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'heroFooterBackground',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'heroFooterBackgroundMobile',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    {
      name: 'showButton',
      type: 'boolean',
      defaultValue: true
    }
  ]
})

const IconCloud = loadable(() => import('components/ui-builder/icon-cloud'))
Builder.registerComponent(IconCloud, {
  name: 'IconCloud',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'icons',
      type: 'list',
      defaultValue: [{ imgSrc: null, alt: 'defaultName' }],
      subFields: [
        { name: 'alt', type: 'string', defaultValue: 'defaultName' },
        { name: 'tag', type: 'string', defaultValue: 'defaultName' },
        // { name: 'iconImage', type: 'cloudinaryImageEditor' },
        {
          name: 'builderIconImage',
          type: 'file',
          allowedFileTypes: ['jpeg', 'png', 'svg']
        },
      ]
    }
  ]
})

const LazyDogNamePreFooter = loadable(() => import('components/ui-builder/dog-name-pre-footer'))
Builder.registerComponent(LazyDogNamePreFooter, {
  name: 'DogNamePreFooter',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'preFooterTextHeadlineOne',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'preFooterTextHeadlineTwo',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'preFooterTextOne',
      type: 'richText',
      defaultValue: ''
    },
    // {
    //   name: 'desktopImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderDesktopImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'preFooterDesktopImgAltText',
      type: 'text',
      default: ''
    },
    // {
    //   name: 'mobileImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderMobileImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'preFooterMobileTextImgAltText',
      type: 'text',
      default: ''
    },
    {
      name: 'mediaBackdropColor',
      type: 'color',
      defaultValue: 'cyan'
    },
    {
      name: 'formBackgroundColor',
      type: 'color',
      defaultValue: '#F9F5F1'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    {
      name: 'widgetBackgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'widgetType',
      type: 'string',
      enum: ['carousel', 'microCombo', 'list'],
      defaultValue: 'microCombo'
    },
    {
      name: 'widgetTags',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'showRating',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'ratingTextBold',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'ratingTextNormalOne',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'ratingTextNormalTwo',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'ratingIcon',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderRatingIcon',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'coupon',
      type: 'text',
      defaultValue: ''
    }
  ]
})

const LazySteps = loadable(() => import('components/ui-builder/steps'))
Builder.registerComponent(LazySteps, {
  name: 'Steps',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#F9F5F1'
    },
    {
      name: 'stepItems',
      type: 'list',
      defaultValue: [{ ...StepItemRegisterProps.defaultValue }],
      subFields: StepItemRegisterProps.subFields
    }
  ]
})

const LazyFooter = loadable(() => import('./components/ui-builder/footer'))
Builder.registerComponent(LazyFooter, {
  name: 'Footer',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: BgFooter
    },
    {
      name: 'logo',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'overallTextColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'footerText',
      type: 'text',
      defaultValue: 'Making the world a better place though'
    },
    {
      name: 'ownerText',
      type: 'text',
      defaultValue: '2020 Workflow, Inc. All rights reserved.'
    },
    {
      name: 'newsletterHeading',
      type: 'text',
      defaultValue: 'Join the pack'
    },
    {
      name: 'newsletterHeadingColor',
      type: 'color',
      defaultValue: 'darkblue'
    },
    {
      name: 'newsletterDescription',
      type: 'text',
      defaultValue: 'Want tips from our vet, tasty discounts and cute dogs in your inbox?'
    },
    {
      name: 'newsletterDescriptionColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'newsLetterButtonBackgroundColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'newsLetterButtonTextColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'newsLetterButtonText',
      type: 'text',
      defaultValue: 'Subscribe'
    },
    {
      name: 'sections',
      type: 'list',
      defaultValue: [
        {
          sectionHeading: 'Main',
          sectionHeadingColor: 'gray',
          items: [{ itemText: 'Marketing', itemUrl: '#', itemColor: 'gray' }]
        }
      ],
      subFields: [
        { name: 'sectionHeading', type: 'string', defaultValue: 'Solutions' },
        { name: 'sectionHeadingColor', type: 'color', defaultValue: 'gray' },
        {
          name: 'items',
          type: 'list',
          subFields: [
            { name: 'itemText', type: 'string', defaultValue: 'Marketing' },
            { name: 'itemUrl', type: 'string', defaultValue: '#' },
            { name: 'itemColor', type: 'color', defaultValue: 'gray' }
          ],
          defaultValue: [{ itemText: 'Marketing', itemUrl: '#', itemColor: 'gray' }]
        }
      ]
    },
    {
      name: 'socials',
      type: 'list',
      subFields: [
        { name: 'type', type: 'string', defaultValue: 'Facebook', enum: ['Facebook', 'Instagram', 'Twitter'] },
        { name: 'href', type: 'string', defaultValue: '#' }
      ],
      defaultValue: [{ type: 'Facebook', href: '#' }]
    },
    {
      name: 'socialIconColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'borderColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'isFirstName',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'isLastName',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'formFieldbg',
      type: 'color',
      defaultValue: '#F6E9DB'
    },
    {
      name: 'formFieldTextColor',
      type: 'color',
      defaultValue: '#5C5C5C'
    }
  ]
})

const LazyFooterAlternate = loadable(() => import('./components/ui-builder/footer-alternate'))
Builder.registerComponent(LazyFooterAlternate, {
  name: 'footer-alternate',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'backgroundImage',
      type: 'file',
      defaultValue: BgFooter
    },
    {
      name: 'backgroundImageMobile',
      type: 'file',
    },
    {
      name: 'logo',
      type: 'file',
      defaultValue: null
    },
    {
      name: 'newsletterHeading',
      type: 'text',
      defaultValue: 'Join the pack'
    },
    {
      name: 'newsletterHeadingColor',
      type: 'color',
      defaultValue: 'darkblue'
    },
    {
      name: 'newsletterDescription',
      type: 'text',
      defaultValue: 'Want tips from our vet, tasty discounts and cute dogs in your inbox?'
    },
    {
      name: 'newsletterDescriptionColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'newsLetterButtonBackgroundColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'newsLetterButtonTextColor',
      type: 'color',
      defaultValue: 'white'
    },
    {
      name: 'newsLetterButtonText',
      type: 'text',
      defaultValue: 'Subscribe'
    },
    {
      name: 'sections',
      type: 'list',
      defaultValue: [
        {
          sectionHeading: 'Main',
          sectionHeadingColor: 'gray',
          items: [{ itemText: 'Marketing', itemUrl: '#', itemColor: 'gray' }]
        }
      ],
      subFields: [
        { name: 'sectionHeading', type: 'string', defaultValue: 'Solutions' },
        { name: 'sectionHeadingColor', type: 'color', defaultValue: 'gray' },
        {
          name: 'items',
          type: 'list',
          subFields: [
            { name: 'itemText', type: 'string', defaultValue: 'Marketing' },
            { name: 'itemUrl', type: 'string', defaultValue: '#' },
            { name: 'itemColor', type: 'color', defaultValue: 'gray' }
          ],
          defaultValue: [{ itemText: 'Marketing', itemUrl: '#', itemColor: 'gray' }]
        }
      ]
    },
    {
      name: 'socials',
      type: 'list',
      subFields: [
        { name: 'type', type: 'string', defaultValue: 'Facebook', enum: ['Facebook', 'Instagram', 'TikTok'] },
        { name: 'href', type: 'string', defaultValue: '#' }
      ],
      defaultValue: [{ type: 'Facebook', href: '#' }]
    },
    {
      name: 'socialIconColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'borderColor',
      type: 'color',
      defaultValue: 'gray'
    },
    {
      name: 'isFirstName',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'isLastName',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'formFieldbg',
      type: 'color',
      defaultValue: '#F6E9DB'
    },
    {
      name: 'formFieldTextColor',
      type: 'color',
      defaultValue: '#5C5C5C'
    },
    // {
    //   name: 'cloudinaryCertifyImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderCertifyImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    // {
    //   name: 'cloudinaryEuFundingImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderEuFundingImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'contentText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'isEUFunding',
      type: 'boolean',
      defaultValue: true
    },
    {
      name: 'footerText',
      type: 'richText',
      defaultValue: ''
    },
    {
      name: 'addressText',
      type: 'text',
      defaultValue: ''
    }
  ]
})

const LazyRecipeBook = loadable(() => import('./components/ui-builder/recipe-book'))
Builder.registerComponent(LazyRecipeBook, {
  name: 'RecipeBook',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: '#F5F1ED'
    },
    {
      name: 'bookBackgroundColor',
      type: 'color',
      defaultValue: 'whtie'
    },
    {
      name: 'bookTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'bookDividerColor',
      type: 'color',
      defaultValue: '#6BA2B3'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    }
  ]
})

const LazyProductFeatures = loadable(() => import('./components/ui-builder/product-features'))
Builder.registerComponent(LazyProductFeatures, {
  name: 'ProductFeatures',
  inputs: [
    // {
    //   name: 'cloudinaryMainImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderMainImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'mainImageAltText',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'cloudinarySecondaryImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderSecondaryImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'secondaryImageAltText',
      type: 'text',
      defaultValue: ''
    },
    // {
    //   name: 'cloudinaryThirdImage',
    //   type: 'cloudinaryImageEditor'
    // },
    {
      name: 'builderThirdImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'png', 'svg']
    },
    {
      name: 'thirdImageAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'squareBackgroundColor',
      type: 'color',
      defaultValue: '#F5F1ED'
    },
    {
      name: 'headingText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'headingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'subHeadingText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'subHeadingTextColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'paragraph',
      type: 'richText',
      defaultValue: 'The main paragraph'
    },
    {
      name: 'paragraphColor',
      type: 'color',
      defaultValue: 'black'
    },
    {
      name: 'imagesPosition',
      type: 'string',
      enum: ['left', 'right'],
      defaultValue: 'right'
    },
    {
      name: 'buttonEnabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      ...LinkButtonRegisterProps,
      name: 'buttonProp'
    },
    {
      name: 'bulletPoint',
      type: 'file',
      defaultValue: BulletPointImage
    },
    {
      name: 'bulletAltText',
      type: 'text',
      defaultValue: ''
    },
    {
      name: 'points',
      type: 'list',
      subFields: [{ name: 'text', type: 'string' }],
      defaultValue: []
    }
  ]
})

Builder.registerComponent(AbTest, {
  name: 'AB Test',
  friendlyName: 'AB Test',
  inputs: [
    {
      name: 'growthbookFeatureId',
      friendlyName: 'Growthbook Feature ID',
      type: 'string',
      defaultValue: ''
    },
    {
      name: 'enabled',
      friendlyName: 'Enabled',
      type: 'boolean',
      defaultValue: false
    },
    {
      name: 'split',
      friendlyName: 'Variant Split',
      type: 'string',
      defaultValue: false
    }
  ],
  canHaveChildren: true,
  models: ['page'],
  defaultChildren: [
    { 
      '@type': '@builder.io/sdk:Element',
      component: { name: 'AbSkeleton' }
    },
    { 
      '@type': '@builder.io/sdk:Element',
      component: { name: 'AbContainer' }
    }
  ]
})

Builder.registerComponent(Container, {
  name: 'Container',
  friendlyName: 'Container',
  inputs: [],
  canHaveChildren: true,
  models: ['page']
})

Builder.registerComponent(AbContainer, {
  name: 'AbContainer',
  friendlyName: 'AB Container',
  inputs: [],
  canHaveChildren: true,
  models: ['page']
})

Builder.registerComponent(AbSkeleton, {
  name: 'AbSkeleton',
  friendlyName: 'AB Skeleton',
  inputs: [
    {
      name: 'backgroundColor',
      type: 'color',
      defaultValue: 'white'
    }
  ],
  canHaveChildren: true,
  models: ['page']
})

builder.init(process.env.GATSBY_BUILDERIO_KEY || process.env.BUILDERIO_KEY)
